import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/crmCustomerProject/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/crmCustomerProject',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/crmCustomerProject',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/crmCustomerProject/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/crmCustomerProject',
    method: 'get',
    params: {
      id
    }
  })
}
export function getDefCustomerById(id) {
  return request({
    url: '/api/crmCustomerProject/getDefCustomerById',
    method: 'get',
    params: {
      id
    }
  })
}
export function noTagPage(params) {
  return request({
    url: '/api/crmCustomerProject/noTagPage',
    method: 'get',
    params
  })
}
